import { spawn } from 'redux-saga/effects';

import commentsSaga from './comments/commentsSaga';
import userSaga from './user/userSaga';
import contentSaga from './content/contentsSaga';

export default function* root() {
  yield spawn(contentSaga);
  yield spawn(commentsSaga);
  yield spawn(userSaga);
}
